export var PopupModal;
(function (PopupModal) {
    PopupModal["Show"] = "PopupModal/Show";
    PopupModal["Hide"] = "PopupModal/Hide";
})(PopupModal || (PopupModal = {}));
